import React, { memo } from "react";
import ListHeader from '../../../../../shared/components/ListHeader';
import ListContainer from '../../../../../shared/components/ListContainer';
import styles from "./listGpsDevicesToUpload.module.scss";
import { useTranslation } from "react-i18next";
import { parseError } from '../../../../helpers/gps';

const ListGpsDevicesToUpload = ({ itemsAvailableToInsert, itemsUnavailableToInsert, unsubscribe = false }) => {

    const { t } = useTranslation(["devices", "home"]);

    return (
        <div className={styles.wrapper} >

            {
                itemsUnavailableToInsert && itemsUnavailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.error}`}>
                        {`${itemsUnavailableToInsert.length} GPS ${t("home:with_conflict")}`}
                    </ListHeader>

                    {!unsubscribe ?
                        <ListHeader className={styles.subHeader}>
                            <div> {t('home:name')} </div>
                            <div> IMEI </div>
                            <div> ICCID </div>
                        </ListHeader>
                        :
                        <ListHeader className={styles.subHeader}>
                            <div> IMEI </div>
                            <div> Error </div>
                        </ListHeader>
                    }

                    <ListContainer>
                        {itemsUnavailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{unsubscribe ? item.imei : item.name}</div>
                                <div>{unsubscribe ? t(`devices:${item.message.toLowerCase()}`) : item.device}</div>
                                {!unsubscribe && <div>{item.simcard}</div>}
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

            {
                itemsAvailableToInsert && itemsAvailableToInsert.length > 0 &&
                <>
                    <ListHeader className={`${styles.header} ${styles.success}`}>
                        {`${itemsAvailableToInsert.length} ${t("home:devices")} ${t("home:redy_to_upload")}`}
                    </ListHeader>

                    <ListHeader className={styles.subHeader}>
                        <div> IMEI </div>
                        <div> ICCID </div>
                        <div> {t('devices:status')} </div>
                    </ListHeader>

                    <ListContainer>
                        {itemsAvailableToInsert.map((item, index) => (
                            <div key={index}>
                                <div>{item.name}</div>
                                <div>{item.device}</div>
                                <div>{item.simcard}</div>
                            </div>
                        ))}
                    </ListContainer>
                </>
            }

        </div>
    )
}

export default memo(ListGpsDevicesToUpload);